import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';

export const entrepreneursThatStartedExportOrImport = (
    props: any,
    baselineKey: string,
    finalKey: string,
    baselineValue: string
): string => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );
    
    const count = filteredFinal.filter((finalSubmission: any) => {
        const baselineSubmission = filteredBaseline.find(
            (baselineSubmission: any) => baselineSubmission[baselineKey] === baselineValue &&
                finalSubmission.uoa_id === baselineSubmission.uoa_id
        );
        
        return finalSubmission[finalKey] === 'Yes' && baselineSubmission
    }).length

    return (count / Math.max(filteredBaseline.length, filteredFinal.length) * 100).toFixed(2);
}